/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * DTO for failed batch job item details
 * @export
 * @interface WebApiBatchJobDtoFailedItemDto
 */
export interface WebApiBatchJobDtoFailedItemDto {
    /**
     * Gets or sets the batch item identifier.
     * @type {number}
     * @memberof WebApiBatchJobDtoFailedItemDto
     */
    batchItemId?: number;
    /**
     * Gets or sets the error message.
     * @type {string}
     * @memberof WebApiBatchJobDtoFailedItemDto
     */
    errorMessage?: string | null;
    /**
     * Gets or sets the number of attempts made.
     * @type {number}
     * @memberof WebApiBatchJobDtoFailedItemDto
     */
    attemptCount?: number;
}

/**
 * Check if a given object implements the WebApiBatchJobDtoFailedItemDto interface.
 */
export function instanceOfWebApiBatchJobDtoFailedItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiBatchJobDtoFailedItemDtoFromJSON(json: any): WebApiBatchJobDtoFailedItemDto {
    return WebApiBatchJobDtoFailedItemDtoFromJSONTyped(json, false);
}

export function WebApiBatchJobDtoFailedItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiBatchJobDtoFailedItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchItemId': !exists(json, 'batchItemId') ? undefined : json['batchItemId'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'attemptCount': !exists(json, 'attemptCount') ? undefined : json['attemptCount'],
    };
}

export function WebApiBatchJobDtoFailedItemDtoToJSON(value?: WebApiBatchJobDtoFailedItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batchItemId': value.batchItemId,
        'errorMessage': value.errorMessage,
        'attemptCount': value.attemptCount,
    };
}

